module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-open-enter",
    on: {
      "click": _vm.hanldeOpenSqWechat
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7992dfc2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/openWechat.vue
// module id = 248
// module chunks = 45